import React from 'react';

export const LazyCustomerManagementPage = React.lazy(async () => {
    return import('./CustomerManagementPage');
});

export const LazyCustomerDetailsPage = React.lazy(async () => {
    return import('./CustomerDetailsPage');
});
